
export const patternWithoutNumbersOnly = '(^\\d+$)';

export const validPattern = '^(?!^[\\d\\s]+$)[\\w\\s]{2,254}$';

export const emptyPattern = /^[\s\u2000-\u200F\u202F]*$/g;
